import exitSearch from '../../actions/search/exitSearch';
import { exitSearch as exitSearchAction, lazyEndSearchSession, SearchScenarioId } from 'owa-search';
import { getFilePickerStore } from '../../store/filePickerStore';
import { orchestrator } from 'satcheljs';

orchestrator(exitSearchAction, async actionMessage => {
    if (actionMessage.scenarioId != SearchScenarioId.FilesPicker) {
        return;
    }
    exitSearch(getFilePickerStore().viewState);

    // invoke endSearchSession common action
    const endSearchSession = await lazyEndSearchSession.import();
    endSearchSession(SearchScenarioId.FilesPicker);
});
